<template>
  <div>
    <div class="alert__container">
      <div class="title__container">
        <h2>
          <v-icon color="#005B96"> mdi-bell-ring </v-icon>
          알림 수신 설정
        </h2>
        <h4>사용자의 알림 수신 여부와 알림 수신 방법을 설정합니다.</h4>
      </div>

      <div class="alertset__container">
        <div class="alert_info">
          <div class="alert_set">
            <div class="alert_title">범위 초과 알림 수신 여부</div>

            <div class="switch-container">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="room_changeup_yn"
                />
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="sub_info">
            측정 데이터가 지정된 최소값과 최대값의 범위를 벗어나면 발생하는
            알림을 수신합니다.
          </div>
        </div>

        <div class="alert_info">
          <div class="alert_set">
            <div class="alert_title">데이터 수신 이상 알림 수신 여부</div>

            <div class="switch-container">
              <label class="switch">
                <input
                  type="checkbox"
                  v-model="data_disable_yn"
                />
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="sub_info">
            일정 시간 이상 측정 데이터의 수신이 없으면 발생하는 알림을
            수신합니다.
          </div>
        </div>

        <div class="alert_info">
          <div class="alert_title mb-2">알림 수신 방법</div>
          <div class="d-flex gap-4 mt-1">
            <v-checkbox v-model="sms_yn" label="문자 메시지" color="#005B96" hide-details class="mt-0" />
            <v-checkbox v-model="vms_yn" label="음성 메시지" color="#005B96" hide-details class="mt-0" />
          </div>
        </div>
      </div>

      <div class="btn__area">
        <v-btn class="save__btn" color="#005B96" dark @click="saveState">저장</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import Apis from "@/api/apis";
export default {
  name: "AlertPersonal",
  data() {
    return {
      room_changeup_yn: false,
      data_disable_yn: false,
      sms_yn: false,
      vms_yn: false,
    };
  },

  async created() {
    Apis.pageCount(
      {
        page_name: this.$route.name,
        url: this.$route.path,
        division: "cloud",
      },
      () => {
        // 정상처리
        // console.log("pageCount 호출",res);
      },
    ).catch((err) => {
      // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류", err);
    });

    await this.infoAlert();
  },
  methods: {
    infoAlert() {
      this.$store.commit("resMessage", "");
      // console.log("Switch "+id);
      // console.log(this.$getters.userInfo.account)

      Apis.infoPersonalChoicedAlerts({}, (res) => {
        if (res.result) {
          // alert(res.message);
          this.$store.commit("resMessage", res.message);
          this.room_changeup_yn = res.data.room_changeup_yn || false;
          this.data_disable_yn = res.data.data_disable_yn || false;
          this.sms_yn = res.data.sms_yn || false;
          this.vms_yn = res.data.vms_yn || false;
        } else {
          console.log("정보 오류", res.message);
        }
      }).catch((err) => {
        // API 오류 처리
        console.log("infoPersonalChoicedAlerts API 호출 오류", err);
        alert(err);
      });
    },
    saveState() {
      this.$store.commit("resMessage", "");

      Apis.savePersonalChoicedAlerts(
        {
          room_changeup_yn: this.room_changeup_yn,
          data_disable_yn: this.data_disable_yn,
          sms_yn: this.sms_yn,
          vms_yn: this.vms_yn,
        },
        (res) => {
          if (res.result) {
            this.$store.commit("resMessage", "알림 수신 설정이 저장되었습니다.");
          } else {
            console.log("저장 오류", res.message);
          }
        },
      ).catch((err) => {
        // API 오류 처리
        console.log("savePersonalChoicedAlerts API 호출 오류", err);
        alert(err);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style/base.scss";

.alert__container {
  margin: 15px;
}
.title__container {
  margin-left: 5px;
  margin-bottom: 20px;
  letter-spacing: -0.75px;
  color: #005b96;
}

.alertset__container {
  padding: 5px;
}
.alert_info {
  margin-bottom: 20px;
  height: 20%;
  padding: 10px 10px 10px 10px;
  border: 1px solid #005b96;
  border-radius: 20px;
  background-color: #fff7de;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
}

.alert_title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #005b96;
}
.alert_set {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.switch-container {
  background-color: transparent;
}
.switch {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  flex-shrink: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: #ccc;
  border-radius: 28px;
  transition: 0.3s;

  &::before {
    content: "";
    position: absolute;
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
  }
}
input:checked + .slider {
  background-color: #005b96;
}
input:checked + .slider::before {
  transform: translateX(24px);
}
.sub_info {
  font-size: 1rem;
  letter-spacing: -1px;
  margin-left: 10px;
  line-height: 50p;
}
.btn__area {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  padding: 0 5px;
}
.close__btn {
  border-color: #005b96 !important;
  color: #005b96 !important;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: -0.5px;
}
.save__btn {
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: -0.5px;
}
.btn__area .save__btn.v-btn {
  color: white !important;
}
.color_green {
  color: #88191a;
  font-weight: 600;
  font-size: 14px;
}
.color_gray {
  color: #ababab;
}
.shortcut_icon {
  width: 18px;
  height: 18px;
  margin-right: 3px;
  filter: invert(23%) sepia(6%) saturate(2314%) hue-rotate(82deg)
    brightness(98%) contrast(78%);
}
</style>
